// extracted by mini-css-extract-plugin
module.exports = {"info":"detail-header_info_36D7c","infoItem":"detail-header_infoItem_2VTAB","text":"detail-header_text_Hybf4","textHidden":"detail-header_textHidden_huDDF"};